/** admin/launch — KEYS. */
export const adminLaunchKeys = {
  all: () => ['admin', 'launch'] as const,
  testPersonas: () => [...adminLaunchKeys.all(), 'test-personas'] as const,
};
